/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';
import type { UsageGrouped } from './UsageGrouped';
import {
    UsageGroupedFromJSON,
    UsageGroupedFromJSONTyped,
    UsageGroupedToJSON,
} from './UsageGrouped';

/**
 * 
 * @export
 * @interface PageableUsagesGrouped
 */
export interface PageableUsagesGrouped {
    /**
     * 
     * @type {Array<UsageGrouped>}
     * @memberof PageableUsagesGrouped
     */
    result: Array<UsageGrouped>;
    /**
     * 
     * @type {Page}
     * @memberof PageableUsagesGrouped
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableUsagesGrouped interface.
 */
export function instanceOfPageableUsagesGrouped(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableUsagesGroupedFromJSON(json: any): PageableUsagesGrouped {
    return PageableUsagesGroupedFromJSONTyped(json, false);
}

export function PageableUsagesGroupedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableUsagesGrouped {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(UsageGroupedFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableUsagesGroupedToJSON(value?: PageableUsagesGrouped | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(UsageGroupedToJSON)),
        'page': PageToJSON(value.page),
    };
}

